<div *ngIf="paymentForm" [formGroup]="paymentForm">
  <!-- Proposition référent -->
  <div class="row">
    <div class="col-12 col-lg-12">
      <p>
        <strong> Proposition référent </strong>
      </p>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start required">Montant du versement</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="paymentAmount420"
          type="radio"
          class="form-check-input"
          formControlName="paymentAmount"
          name="paymentAmount"
          [value]="+420"
          [class.is-invalid]="submitted && paymentForm.controls.paymentAmount.invalid"
        />
        <label for="paymentAmount420" class="form-check-label">420€</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="paymentAmount315"
          type="radio"
          class="form-check-input"
          formControlName="paymentAmount"
          name="paymentAmount"
          [value]="+315"
          [class.is-invalid]="submitted && paymentForm.controls.paymentAmount.invalid"
        />
        <label for="paymentAmount315" class="form-check-label">315€</label>
      </div>
    </div>
    <small *ngIf="submitted && paymentForm.controls?.paymentAmount?.errors?.required" class="form-text text-danger mt-0"
      >Le montant est obligatoire.</small
    >
    <small class="form-text text-secondary mt-0">Avant le 01/03/2023, les montants étaient de 400 et 300€.</small>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start required">Durée du versement</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="paymentDuration1"
          type="radio"
          class="form-check-input"
          formControlName="paymentDuration"
          name="paymentDuration"
          [value]="1"
          [class.is-invalid]="submitted && paymentForm.controls.paymentDuration.invalid"
        />
        <label for="paymentDuration1" class="form-check-label">1 mois</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="paymentDuration2"
          type="radio"
          class="form-check-input"
          formControlName="paymentDuration"
          name="paymentDuration"
          [value]="2"
          [class.is-invalid]="submitted && paymentForm.controls.paymentDuration.invalid"
        />
        <label for="paymentDuration2" class="form-check-label">2 mois</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="paymentDuration3"
          type="radio"
          class="form-check-input"
          formControlName="paymentDuration"
          name="paymentDuration"
          [value]="3"
          [class.is-invalid]="submitted && paymentForm.controls.paymentDuration.invalid"
        />
        <label for="paymentDuration3" class="form-check-label">3 mois</label>
      </div>
    </div>
    <small *ngIf="submitted && paymentForm.controls?.paymentDuration?.errors?.required" class="form-text text-danger mt-0"
      >La durée est obligatoire.</small
    >
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start required">Avis</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="paymentOpinionPositive"
          type="radio"
          class="form-check-input"
          formControlName="paymentOpinion"
          name="paymentOpinion"
          [value]="RsjInstructionPaymentOpinion.Positive"
          [class.is-invalid]="submitted && paymentForm.controls.paymentOpinion.invalid"
        />
        <label for="paymentOpinionPositive" class="form-check-label">{{ RsjInstructionPaymentOpinion.Positive }}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="paymentOpinionNeutral"
          type="radio"
          class="form-check-input"
          formControlName="paymentOpinion"
          name="paymentOpinion"
          [value]="RsjInstructionPaymentOpinion.Neutral"
          [class.is-invalid]="submitted && paymentForm.controls.paymentOpinion.invalid"
        />
        <label for="paymentOpinionNeutral" class="form-check-label">{{ RsjInstructionPaymentOpinion.Neutral }}</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="paymentOpinionNegative"
          type="radio"
          class="form-check-input"
          formControlName="paymentOpinion"
          name="paymentOpinion"
          [value]="RsjInstructionPaymentOpinion.Negative"
          [class.is-invalid]="submitted && paymentForm.controls.paymentOpinion.invalid"
        />
        <label for="paymentOpinionNegative" class="form-check-label">{{ RsjInstructionPaymentOpinion.Negative }}</label>
      </div>
    </div>
    <small *ngIf="submitted && paymentForm.controls?.paymentOpinion?.errors?.required" class="form-text text-danger mt-0"
      >L'avis est obligatoire.</small
    >
  </div>
  <div class="row">
    <div class="col-12 mb-3">
      <label [class.required]="requiredComment">Commentaire</label>
      <textarea
        class="form-control"
        formControlName="paymentComment"
        [class.is-invalid]="submitted && paymentForm.controls?.paymentComment?.invalid"
      ></textarea>
      <small *ngIf="submitted && paymentForm.controls?.paymentComment?.invalid" class="form-text text-danger">Le commentaire est obligatoire</small>
    </div>
  </div>
  <!-- Contre-proposition -->
  <div class="row">
    <div class="col-12 col-lg-12">
      <p>
        <strong> Contre-proposition </strong>
      </p>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start">Proposition référent acceptée ?</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="paymentCounterProposalFalse"
          type="radio"
          class="form-check-input"
          formControlName="paymentCounterProposal"
          name="paymentCounterProposal"
          [value]="false"
        />
        <label for="paymentCounterProposalFalse" class="form-check-label">Oui</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="paymentCounterProposalTrue"
          type="radio"
          class="form-check-input"
          formControlName="paymentCounterProposal"
          name="paymentCounterProposal"
          [value]="true"
        />
        <label for="paymentCounterProposalTrue" class="form-check-label">Non</label>
      </div>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start" [ngClass]="{ required: paymentForm.controls.paymentCounterProposal.value }">Montant du versement</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="paymentCounterAmount420"
          type="radio"
          class="form-check-input"
          formControlName="paymentCounterAmount"
          name="paymentCounterAmount"
          [value]="+420"
          [class.is-invalid]="submitted && paymentForm.controls.paymentCounterAmount.invalid"
        />
        <label for="paymentCounterAmount420" class="form-check-label">420€</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="paymentCounterAmount315"
          type="radio"
          class="form-check-input"
          formControlName="paymentCounterAmount"
          name="paymentCounterAmount"
          [value]="+315"
          [class.is-invalid]="submitted && paymentForm.controls.paymentCounterAmount.invalid"
        />
        <label for="paymentCounterAmount315" class="form-check-label">315€</label>
      </div>
    </div>
    <small *ngIf="submitted && paymentForm.controls?.paymentCounterAmount?.errors?.required" class="form-text text-danger mt-0"
      >Le montant de la contre-proposition est obligatoire.</small
    >
    <small class="form-text text-secondary mt-0">Avant le 01/03/2023, les montants étaient de 400 et 300€.</small>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start" [ngClass]="{ required: paymentForm.controls.paymentCounterProposal.value }">Durée du versement</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="paymentCounterDuration1"
          type="radio"
          class="form-check-input"
          formControlName="paymentCounterDuration"
          name="paymentCounterDuration"
          [value]="1"
          [class.is-invalid]="submitted && paymentForm.controls.paymentCounterDuration.invalid"
        />
        <label for="paymentCounterDuration1" class="form-check-label">1 mois</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="paymentCounterDuration2"
          type="radio"
          class="form-check-input"
          formControlName="paymentCounterDuration"
          name="paymentCounterDuration"
          [value]="2"
          [class.is-invalid]="submitted && paymentForm.controls.paymentCounterDuration.invalid"
        />
        <label for="paymentCounterDuration2" class="form-check-label">2 mois</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="paymentCounterDuration3"
          type="radio"
          class="form-check-input"
          formControlName="paymentCounterDuration"
          name="paymentCounterDuration"
          [value]="3"
          [class.is-invalid]="submitted && paymentForm.controls.paymentCounterDuration.invalid"
        />
        <label for="paymentCounterDuration3" class="form-check-label">3 mois</label>
      </div>
    </div>
    <small *ngIf="submitted && paymentForm.controls?.paymentCounterDuration?.errors?.required" class="form-text text-danger mt-0"
      >La durée de la contre-proposition est obligatoire.</small
    >
  </div>
  <div class="row">
    <div class="col-12 mb-3">
      <label [ngClass]="{ required: paymentForm.controls.paymentCounterProposal.value }">Commentaire</label>
      <textarea
        class="form-control"
        formControlName="paymentCounterComment"
        [class.is-invalid]="submitted && paymentForm.controls.paymentCounterComment.invalid"
      ></textarea>
    </div>
    <small *ngIf="submitted && paymentForm.controls?.paymentCounterComment?.errors?.required" class="form-text text-danger"
      >Un commentaire pour la contre-proposition est obligatoire.</small
    >
  </div>
</div>
